import { render, staticRenderFns } from "./delayDialog.vue?vue&type=template&id=1bfc7571&scoped=true"
import script from "./delayDialog.vue?vue&type=script&lang=js"
export * from "./delayDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfc7571",
  null
  
)

export default component.exports